import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { ForgotPasswordPageComponent } from './pages/forgot-password-page/forgot-password-page.component';
import { SetNewPasswordComponent } from './pages/set-new-password/set-new-password.component';
import { SetOwnPasswordComponent } from './pages/set-own-password/set-own-password.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { ForgotPasswordAfterloginComponent } from './pages/forgot-password-afterlogin/forgot-password-afterlogin.component';
import { CreateNewPasswordComponent } from './pages/create-new-password/create-new-password.component';
import { AccountDetailsComponent } from './pages/account-details/account-details.component';
import { AccountHeaderComponent } from './pages/account-header/account-header.component';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AccountInfoComponent } from './pages/account-info/account-info.component';
import { AccountMgaComponent } from './pages/account-mga/account-mga.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { GotoGetReliableComponent } from './pages/goto-get-reliable/goto-get-reliable.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import{SecondPipePipe} from '../shared/pipes/second-pipe.pipe';
import {NgxPaginationModule} from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import {BlockUIModule} from 'ng-block-ui';
import {BlockUIHttpModule} from 'ng-block-ui/http';
import { PaymentLinkComponent } from './pages/payment-link/payment-link.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaModule, RecaptchaV3Module } from 'ng-recaptcha';
import { ChangeOldPasswordComponent } from './pages/change-old-password/change-old-password.component';
import { MiscDocumentPipePipe } from '../shared/pipes/misc-document-pipe.pipe';
import { BrokerRedirectComponent } from './pages/broker-redirect/broker-redirect.component';

@NgModule({
  declarations: [LoginLayoutComponent,SecondPipePipe,LoginPageComponent,ForgotPasswordPageComponent, SetNewPasswordComponent, SetOwnPasswordComponent, ChangePasswordComponent, ForgotPasswordAfterloginComponent, CreateNewPasswordComponent, AccountDetailsComponent, AccountHeaderComponent, AccountInfoComponent, AccountMgaComponent, GotoGetReliableComponent, PaymentLinkComponent, ChangeOldPasswordComponent,MiscDocumentPipePipe, BrokerRedirectComponent],
  imports: [
    CommonModule,
    LoginRoutingModule,
    FormsModule,
    BlockUIModule.forRoot({
      message: 'Loading...'
    }),
  BlockUIHttpModule.forRoot(),
    ReactiveFormsModule,
    AngularMultiSelectModule,OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxPaginationModule,
    NgSelectModule,
    RecaptchaV3Module,ReactiveFormsModule
  ],
    providers: [
 {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: '6LcvOU4rAAAAADSer-apdkpVlSOOm8M05DbJ8hgs' 
    }
],
})
export class LoginModule { }
